import WSProvider from './provider/WSProvider';
import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');

var serviceName = "index";

var VitrinService = {
    VitrinGuncelle(islemTuru, urunId, deger) {
        //islemTuru == kampanya ise kampanya listesinde
        //islemTuru == anasayfa olursa anasayfa ürünleri
        var userDataKader =  JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                serviceName: "urun",
                methodName: "vitrinGuncelle",
                islemTuru : islemTuru,
                urunId : urunId,
                deger : deger,
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    VitrinOku(islemTuru){
        //islemTuru == kampanya ise kampanya listesinde
        //islemTuru == anasayfa olursa anasayfa ürünleri
        var userDataKader =  JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))))
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                serviceName: "urun",
                methodName: "vitrinOku",
                islemTuru : islemTuru,
            }
        };
        var result = new Promise(function(resolve, reject){
            WSProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
}


export default VitrinService;